import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead 
        title="Termos de Serviço"
        description="Termos de Serviço do FinaNews - Regras e diretrizes para usar nossa plataforma."
      />
      <Header onSearch={() => {}} />
      
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-12">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-8">
          Termos de Serviço
        </h1>
        
        <div className="prose prose-lg max-w-none text-slate-700 space-y-6">
          <p className="text-lg">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </p>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar o FinaNews, você aceita e concorda em estar vinculado aos termos e 
              disposições deste acordo.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. Uso do Serviço</h2>
            <p>
              O FinaNews fornece serviços de agregação e reescrita de notícias financeiras. Nosso conteúdo 
              é obtido de fontes confiáveis de notícias financeiras e reescrito apenas para fins educacionais e 
              informativos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. Isenção de Responsabilidade sobre o Conteúdo</h2>
            <p>
              Todo o conteúdo do FinaNews é apenas para fins informativos e não deve ser considerado 
              como consultoria financeira. Sempre consulte profissionais financeiros qualificados antes de tomar 
              decisões de investimento.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">4. Direitos Autorais e Atribuição</h2>
            <p>
              Todos os artigos são reescritos e adaptados de fontes originais. Fornecemos atribuição clara 
              e links para as fontes originais. Nosso conteúdo reescrito é original e não infringe 
              leis de direitos autorais.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">5. Conduta do Usuário</h2>
            <p>
              Os usuários concordam em não:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Usar o serviço para quaisquer fins ilegais</li>
              <li>Tentar obter acesso não autorizado aos nossos sistemas</li>
              <li>Distribuir malware ou conteúdo prejudicial</li>
              <li>Violar quaisquer leis ou regulamentos aplicáveis</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">6. Limitação de Responsabilidade</h2>
            <p>
              O FinaNews não será responsável por quaisquer danos indiretos, incidentais, especiais, consequentes ou 
              punitivos resultantes do seu uso ou incapacidade de usar o serviço.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">7. Alterações nos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. O uso continuado do serviço 
              após as alterações constitui aceitação dos novos termos.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;